// // src/components/InstallPWA.jsx
// import { useEffect, useState } from "react";
// import { FiDownload, FiX } from "react-icons/fi"; // npm i react-icons

// export default function InstallPWA() {
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     // user ne pehle "Not now" kiya ho to dobara mat dikhana
//     const dismissed = localStorage.getItem("stb_install_dismissed") === "1";
//     if (dismissed) return;

//     const handleBeforeInstallPrompt = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setVisible(true);
//     };

//     const handleInstalled = () => {
//       setVisible(false);
//       setDeferredPrompt(null);
//       localStorage.removeItem("stb_install_dismissed");
//       console.log("ShowTimeBro installed 🎉");
//     };

//     window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
//     window.addEventListener("appinstalled", handleInstalled);

//     return () => {
//       window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
//       window.removeEventListener("appinstalled", handleInstalled);
//     };
//   }, []);

//   const handleInstall = async () => {
//     if (!deferredPrompt) return;
//     deferredPrompt.prompt();
//     const result = await deferredPrompt.userChoice;
//     console.log("User choice:", result.outcome);

//     setDeferredPrompt(null);
//     setVisible(false);
//   };

//   const handleClose = () => {
//     setVisible(false);
//     localStorage.setItem("stb_install_dismissed", "1");
//   };

//   // Agar already standalone mode me chal rahi hai (installed) to kuch mat dikhao
//   if (
//     !visible ||
//     typeof window === "undefined" ||
//     window.matchMedia("(display-mode: standalone)").matches
//   ) {
//     return null;
//   }

//   return (
//     <div
//       className="fixed inset-x-0 bottom-4 z-[9999] flex justify-center px-4"
//       style={{ animation: "stb-slide-up 0.35s ease-out" }}
//     >
//       <div className="flex max-w-md flex-1 items-center gap-3 rounded-2xl bg-slate-900/95 px-4 py-3 shadow-2xl backdrop-blur">
//         {/* App icon */}
//         <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-2xl bg-slate-800">
//           <img
//             src="/icons/icon-192x192.png"
//             alt="ShowTimeBro"
//             className="h-full w-full object-cover"
//           />
//         </div>

//         {/* Text */}
//         <div className="flex-1 text-sm">
//           <div className="font-semibold text-white">Install ShowTimeBro</div>
//           <div className="text-xs text-slate-300">
//             Get faster access to your tickets and events, directly from your home screen.
//           </div>
//         </div>

//         {/* Actions */}
//         <div className="flex items-center gap-2">
//           <button
//             onClick={handleInstall}
//             className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-3 py-1.5 text-xs font-semibold text-slate-900 hover:bg-amber-300"
//           >
//             <FiDownload size={14} />
//             <span>Install</span>
//           </button>

//           <button
//             onClick={handleClose}
//             className="rounded-full p-1 text-slate-400 hover:bg-slate-800 hover:text-slate-200"
//             aria-label="Close"
//           >
//             <FiX size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


// src/components/InstallPWA.jsx
import { useEffect, useState } from "react";
import { FiDownload, FiX, FiShare2, FiHome } from "react-icons/fi";

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [mode, setMode] = useState(null); // 'android' | 'ios' | null

  useEffect(() => {
    if (typeof window === "undefined") return;

    const dismissed = localStorage.getItem("stb_install_dismissed") === "1";
    if (dismissed) return;

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (isStandalone) return;

    const ua = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    //-------------------------
    // 🍎 iPhone logic
    //-------------------------
    if (isIOS && isSafari) {
      setMode("ios");

      // Show popup after slight delay or scroll
      let triggered = false;

      const show = () => {
        if (!triggered) {
          setVisible(true);
          triggered = true;
        }
      };

      setTimeout(show, 2500);
      window.addEventListener("scroll", () => {
        if (window.scrollY > 120) show();
      });

      return;
    }

    //-------------------------
    // 🤖 Android logic
    //-------------------------
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setMode("android");
      setTimeout(() => setVisible(true), 2000);
    };

    const handleInstalled = () => {
      setVisible(false);
      localStorage.removeItem("stb_install_dismissed");
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem("stb_install_dismissed", "1");
  };

  if (!visible || !mode) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-end justify-center px-5 backdrop-blur-sm bg-black/20">
      <div
        className="w-full max-w-md rounded-2xl bg-white/95 shadow-2xl p-4 mb-6 animate-slide-up"
        style={{ backdropFilter: "blur(12px)" }}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <span className="font-bold text-lg text-slate-900">
            Install ShowTimeBro 🎟
          </span>
          <button onClick={dismiss} className="text-slate-500 hover:text-black">
            <FiX size={20} />
          </button>
        </div>

        {/* App Icon */}
        <div className="flex items-center gap-3 mb-3">
          <img
            src="/icons/icon-192x192.png"
            alt="ShowTimeBro"
            className="h-12 w-12 rounded-xl"
          />
          <div>
            <div className="font-semibold text-slate-900">ShowTimeBro</div>
            <div className="text-xs text-slate-500">Events • Booking • Live Shows</div>
          </div>
        </div>

        {/* Message Section */}
        {mode === "android" && (
          <p className="text-sm text-slate-700 mb-4">
            Install the app for fast access to events, Tickets, wishlist and profile.
          </p>
        )}

        {mode === "ios" && (
          <div className="text-sm text-slate-700 space-y-2 mb-4">
            <p>To install ShowTimeBro on your iPhone:</p>
            <ol className="list-decimal pl-5 space-y-1">
              <li className="flex gap-1 items-center">
                Tap the <FiShare2 /> Share button
              </li>
              <li className="flex gap-1 items-center">
                Select <FiHome /> "Add to Home Screen"
              </li>
              <li>Tap <strong>Add</strong></li>
            </ol>
          </div>
        )}

        {/* Button */}
        <button
          onClick={mode === "android" ? handleInstall : dismiss}
          className="w-full py-2.5 bg-amber-500 text-slate-900 font-semibold rounded-xl hover:bg-amber-400 transition"
        >
          {mode === "android" ? "Install Now" : "Got it 👍"}
        </button>
      </div>
    </div>
  );
}
